import { Typography, styled } from "@mui/material"

export const SideNavTitle = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.pxToRem(12),
  fontWeight: 500,
  textTransform: "uppercase",
  color: theme.palette.p3Components.sideNavTitle,
  paddingLeft: theme.spacing(0.5),
  paddingBottom: theme.spacing(1),
}))
